snt-faq-filter-slider {
  &.float-fill, .float-fill & {
    display: block;
    background-color: $color-grey-03;
    color: $color-black;

    .filter-container {
      background-color: $color-white;
    }
  }

  .wrapper {
    position: relative;
    overflow: hidden;
    box-shadow: 0.2px 0.2px 10px $color-grey-06;
    margin: 0 auto 20px;
  }

  .right-gradient {
    position: absolute;
    pointer-events: none;
    right: 0px;
    top: 0px;
    width: 21px;
    height: 45px;
    z-index: 1;
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
  }

  .left-gradient {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 21px;
    height: 45px;
    z-index: 1;
    background-image: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
    pointer-events: none;
  }

  .filter-container {
    position: relative;
    width: 100%;
    height: 53px;
    line-height: 43px;
    text-align: center;
    overflow-x: scroll;
    padding: 0px;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    margin-bottom: -10px;
    scrollbar-color: transparent transparent;
  }

  nav {
    width: 100%;
  }

  ul {
    width: 100%;
    list-style: none;
    display: inline-block;
    margin: 0px 7px 0px 7px;
    padding: 0px;
    overflow-y: hidden;
    overflow-x: scroll;
    height: 53px;
    white-space: nowrap;
  }

  li {
    color: $color-black;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 21px;
    overflow: hidden;
    display: inline-flex;
    justify-items: center;
    justify-content: space-between;
    flex-direction: column;
    padding:5px 13px;
  }

  a {
    color: $color-black;
    font-size: 16px;
    font-family: "Averta-Regular", Arial,Helvetica, sans-serif;
    letter-spacing: 0;
    line-height: 21px;
    width: auto;
    height: 21px;
    text-decoration: none;

    &:focus {
      display: inline;
      outline-offset: 3px;
      outline: 2px solid $color-primary-accent;
    }
  }

  a:hover {
    color: $color-primary-accent;
    text-decoration: none !important;
    font-family: "Averta-ExtraBold", Arial,Helvetica, sans-serif;
    font-weight: bold;
  }

  .bold-hidden {
    display: block;
    font-weight: bold;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }

  a.active,
  a:focus {
    position: relative;
    color: $color-primary-accent;
    font-family: "Averta-Regular", Arial,Helvetica, sans-serif;
  }

  a.active {
    color: $color-gray;

    &:hover {
      color: $color-primary-accent !important;
      text-decoration: none !important;
      font-family: "Averta-ExtraBold", Arial,Helvetica, sans-serif;
      font-weight: bold;
    }

  }

  a.active:after {
    content: "";
    position: absolute;
    bottom: 0px;
    margin: 0 auto;
    left: 0;
    right: 0;
    height: 2px;
    width: 100%;
    background: $color-primary-accent;
  }


  ::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
  }

  li:first-child {
    margin-left: 30px;
  }

  li:last-child {
    margin-right: 30px;
  }

  .spacings {
    @include layout();
    padding-left: 0;
    padding-right: 0;
  }

  @include viewport($viewport-md) {
    .spacings {
      padding-left: 2.313em;
      padding-right: 2.313em;
    }

    .right-gradient {
      width: 100px;
    }

    .left-gradient {
      width: 100px;
    }

    li:first-child {
      margin-left: 75px;
    }

    li:last-child {
      margin-right: 75px;
    }
  }

  @include viewport($viewport-lg) {
    .spacings {
      padding-left: 4.438em;
      padding-right: 4.438em;
    }
  }

  @include viewport($viewport-xl) {
    .spacings {
      padding-left: 8.438em;
      padding-right: 8.438em;
    }
  }

  &.hide-desktop {
    @include viewport(($viewport-lg, $viewport-xl)) {
      .wrapper {
        display: none;
      }
    }
  }

  .hide {
    display: none;
  }
}
